const decodeBase64Url = (value: string) => {
    const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    return atob(padded);
};

export const isAccessTokenExpired = (accessToken: string) => {
    if (!accessToken) return true;

    const payload = accessToken.split(".")[1];
    if (!payload) return false;

    try {
        const parsed = JSON.parse(decodeBase64Url(payload)) as { exp?: unknown };
        if (typeof parsed.exp !== "number") return false;
        return parsed.exp * 1000 <= Date.now();
    } catch {
        return false;
    }
};
